import { render, staticRenderFns } from "./ActivityLogsTable.vue?vue&type=template&id=1901f604&scoped=true&"
import script from "./ActivityLogsTable.vue?vue&type=script&lang=ts&"
export * from "./ActivityLogsTable.vue?vue&type=script&lang=ts&"
import style0 from "./ActivityLogsTable.vue?vue&type=style&index=0&id=1901f604&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1901f604",
  null
  
)

export default component.exports